import { TimeToLeaveRounded } from '@mui/icons-material';
import { ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import React from 'react';
import { Translate } from 'react-jhipster';
import { Link } from 'react-router-dom';

interface IHome {
  drawerIsOpen: boolean;
}

export const Assets = ({ drawerIsOpen }: IHome) => {
  const initialTheme = localStorage.getItem('USER_THEME') as 'light' | 'dark' | null;

  return (
    <Tooltip title={drawerIsOpen ? '' : <Translate contentKey="global.menu.asset">Ativos</Translate>} placement="right">
      <ListItemButton
        component={Link}
        to="/truck-implement"
        sx={{
          pl: { xs: '18px', md: '32px' },
          '&:hover': {
            color: initialTheme === 'light' ? '#000814' : '#ABADC6',
          },
        }}
      >
        <ListItemIcon>
          <TimeToLeaveRounded />
        </ListItemIcon>
        <ListItemText
          primary={<Translate contentKey="global.menu.asset">Ativos</Translate>}
          primaryTypographyProps={{
            fontSize: '14px',
          }}
          sx={{ opacity: open ? 1 : 0 }}
        />
      </ListItemButton>
    </Tooltip>
  );
};
